import { ChartOptionsProvider, CHART_FLEXED_COLOUR, CHART_HISTORIC_COLOUR, CHART_FORECAST_COLOUR, CHART_FLEXED_MARKER } from './chart-options';
import { Injectable } from '@angular/core';

@Injectable()
export class FaiOptionsProvider extends ChartOptionsProvider {
    public getOptions(company, flexedData = {}, flexed = false) {
        let chartOptions;
        const faiForecast = company.platformData.faiForecast,
            flexedFai = flexedData['valueDrivers'] ? flexedData['valueDrivers']['fai'] : [],
            faiHistoric = company.platformData.faiHistoric.filter(f => f.value !== null);
            const faiHistoricPercent = (faiHistoric[faiHistoric.length - 1].value*100).toFixed(1);

        chartOptions = {
            chart: Object.assign(this.defaultChartOptions.chart,{spacingBottom: 80}),
            credits: {
              enabled: true,
              text: `Trailing FAI: ${faiHistoricPercent}%`,
              style: {
                color: "#333",
                cursor: "pointer",
                fontSize: "12px"
              },
              position: {
                align: 'left',
                verticalAlign: 'bottom',
                x: 10,
                y: -20
              }
            },
            title: 'Fixed Asset Intensity (%)',
            legend: this.defaultChartOptions.legend,
            xAxis: {
                categories: [
                    ...faiHistoric.map(item => item.year),
                    faiForecast.map(item => item.year)
                ]
            },
            yAxis: {
                title: {
                    text: null
                }
            },
            tooltip: this.defaultChartOptions.tooltip,
            series: [
                {
                    name: 'Historic',
                    data: faiHistoric.map(item => [item.year, item.value * 100]),
                    visible: true
                },
                {
                    name: 'Forecast',
                    data: faiForecast.map(item => [item.year, item.value * 100]),
                    visible: true
                }]
        }
        if (flexed) {
            chartOptions.series.push(
                {
                name: 'Flexed Values',
                data: flexedFai.map(item => [item.year, item.value * 100]),
                visible: true,
                color: CHART_FLEXED_COLOUR,
                marker: {
                  symbol: CHART_FLEXED_MARKER
                }
            });
        }
        chartOptions = this.setYMax(chartOptions);
        chartOptions = this.setYMin(chartOptions);

        return super.getOptions(company, chartOptions);
    };
}



// WEBPACK FOOTER //
// ./src/providers/chart-options/fai.ts